import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {Controller, useFieldArray, useForm, useWatch} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {saveCompanyMatrix} from "../common/api/WebApi";
import {NativeSelect} from "@mui/material";
import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import Icon from "@mui/material/Icon";
import Divider from "@mui/material/Divider";

export default function ManageEventMatrixModal({matrix, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);

  const [perkTypes, setPerkTypes] = useState([]);
  const [matrixCodeTypes, setMatrixCodeTypes] = useState([]);

  const {register, handleSubmit, setValue, control, reset} = useForm({
    defaultValues: {
      name: matrix?.name,
      id: matrix?.id,
      guid: matrix?.guid,
      requireAdultAttendee: matrix?.requireAdultAttendee,
      requireChildAttendee: matrix?.requireChildAttendee,
      description: matrix?.description,
      entries: matrix?.entries || []
    }
  });

  const [errorMessage, setErrorMessage] = useState(null);
  const saveMatrixCodeItem = (m) => {
    let _d = {...m};
    _d.guid = matrix?.guid;
    _d.assignedInventoryTypeIds = (_d.assignedInventoryTypeIds || []).map(Number);
    saveCompanyMatrix(_d).then(result => {
      handleSave(_d);
    }).catch((err) => {
      setErrorMessage(err?.response?.data?.message || 'Invalid matrix code');
    });
  }

  const {fields, append, remove} = useFieldArray({
    control,
    name: "entries"
  });

  useEffect(() => {
    if (matrix?.entries) {
      const sorted = [...matrix?.entries].sort(
        (a, b) => a.id - b.id
      );
      reset({entries: sorted});
    }
  }, [matrix?.entries, reset]);


  const addEntry = () => {
    append({
      price: 0,
      adult: false,
      infant: false,
      numComplimentary: '',
      discountAmount: '',
      minValue: '',
      maxValue: '',
      minDateType: 1,
      maxDateType: 1,
    });
  };

  const [matrixCodeTypeId, setMatrixCodeTypeId] = useState(-1);

  const entries = useWatch({
    control,
    name: "entries"
  });

  const EntryRow = ({control, index, setValue}) => {
    return (
      <Grid container spacing={2} key={index}>
        <Grid item sm={12}>
          <label>
            <Controller
              name={`entries.${index}.adult`}
              control={control}
              render={({field}) => (
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    field.onChange(checked);
                    if (checked) {
                      setValue(`entries.${index}.infant`, false);
                    }
                  }}
                />
              )}
            /> Adult </label>
            <br/>
            <small>Adult removes age restrictions and is applied to family not marked as Child.</small>
          <Divider/>
          <label>
            <Controller
              name={`entries.${index}.infant`}
              control={control}
              render={({field}) => (
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  onChange={(e) => {
                    const checked = e.target.checked;
                    field.onChange(checked);
                    if (checked) {
                      setValue(`entries.${index}.adult`, false);
                    }
                  }}
                />
              )}
            /> Infant </label>
            <br/>
            <small>Infant option applies infant discount when any other purchase item is present. If left blank,
              discount will be applied only to corresponding tiers.</small>

        </Grid>
      </Grid>
    );
  };

  return (
    <Modal onHide={handleClose} size={'xl'} show={show}>
      <form
        onSubmit={handleSubmit(saveMatrixCodeItem)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{matrix?.guid ? 'Edit' : 'Create'} Matrix</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        required
                        variant="outlined" type="text"
                        {...register('name')}
                        placeholder="Enter Matrix Title"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="name"
                        label="Matrix Title"/>
                    </div>
                  </Col>

                </Row>

                <Row className={'mt-4'}>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('description')}
                        placeholder="Internal Description"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="name"
                        label="Matrix Description"/>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={4} xs={4}>
                    <div className="form-group">
                      <label>
                        <Controller
                          name={'requireAdultAttendee'}
                          control={control}
                          render={({field}) => (
                            <Checkbox
                              {...field}
                              checked={!!field.value}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                field.onChange(checked);
                                if (checked) {
                                  // setValue(`entries.${index}.infant`, false);
                                }
                              }}
                            />
                          )}
                        /> Require Adult Attendee</label>
                      <br/>
                      <small>Require an adult attendee at time of booking.</small>
                    </div>
                  </Col>

                  <Col className={'col'} sm={4} xs={4}>
                    <div className="form-group">
                      <label>
                        <Controller
                          name={'requireChildAttendee'}
                          control={control}
                          render={({field}) => (
                            <Checkbox
                              {...field}
                              checked={!!field.value}
                              onChange={(e) => {
                                const checked = e.target.checked;
                                field.onChange(checked);
                                if (checked) {
                                  // setValue(`entries.${index}.infant`, false);
                                }
                              }}
                            />
                          )}
                        /> Require Child Attendee</label>
                      <br/>
                      <small>Require a child attendee at time of booking.</small>
                    </div>
                  </Col>
                </Row>

                {fields?.sort((a, b) => a.id - b.id).map((entry, idx) => {
                  return (
                    <div key={entry.id} className={'psb-bordered mt-4'}>
                      <Grid container>
                        <Grid item xs={12} sm={12}>
                          <Row>

                            <Col sm={6} xs={12}>
                              <h6>Enter Pricing</h6>
                              <Grid container spacing={2}>
                                <Grid item sm={6}>
                                  <MDInput type="text" step="0.01" required
                                           {...register(`entries[${idx}].price`, {
                                             setValueAs: (value) => {
                                               if (value === null) {
                                                 return 0;
                                               }
                                               const cleaned = typeof value === 'string' ? value?.replace(/[^0-9.]/g, '') : value;
                                               const parsed = parseFloat(cleaned);
                                               return isNaN(parsed) ? 0 : parseFloat(parsed.toFixed(2));
                                             }
                                           })}
                                           InputProps={{
                                             startAdornment: <span className={'fa fa-dollar'}></span>
                                           }}
                                           InputLabelProps={{shrink: true}}
                                           defaultValue={'0.00'}
                                           autoComplete="off"
                                           name={`entries[${idx}].price`}
                                           className="form-control" id={`entries[${idx}].price`}
                                           label="Price"
                                           placeholder="Price"/>
                                </Grid>
                                <Grid item sm={6}>
                                  <MDInput type="text" step="0.01"
                                           {...register(`entries[${idx}].discountAmount`, {
                                             setValueAs: (value) => {
                                               if (value === null) {
                                                 return '';
                                               }
                                               const cleaned = typeof value === 'string' ? value?.replace(/[^0-9.]/g, '') : value;
                                               const parsed = parseFloat(cleaned);
                                               return isNaN(parsed) ? 0 : parseFloat(parsed.toFixed(2));
                                             }
                                           })}
                                           InputProps={{
                                             startAdornment: <span className={'fa fa-dollar'}></span>
                                           }}
                                           InputLabelProps={{shrink: true}}
                                           autoComplete="off"
                                           name={`entries[${idx}].discountAmount`}
                                           className="form-control" id={`entries[${idx}].discountAmount`}
                                           label="Discount Price"
                                           placeholder="Discount Price"/>

                                </Grid>
                              </Grid>
                              <p><small>Discounts applied to corresponding purchase unless Infant option is
                                selected.</small></p>

                              <MDInput type="number"
                                       min={1}
                                       {...register(`entries[${idx}].numComplimentary`, {
                                         valueAsNumber: true
                                       })}
                                       InputLabelProps={{shrink: true}}
                                       label="Number Complimentary"
                                       placeholder="Number Complimentary"
                                       className="form-control"
                                       autoComplete="off"
                                       id={`entries[${idx}].numComplimentary`}/>
                              <p><small>Apply complimentary rate to first defined attendees. After entry threshold is
                                reached, defined price is charged.</small></p>
                            </Col>

                            <Col sm={6} xs={12}>
                              <h6>Attendee Options</h6>
                              <Grid container>
                                <Grid item xs={11}>
                                  <EntryRow control={control} index={idx} setValue={setValue}/>
                                </Grid>
                                <Grid item xs={1}>
                                  <MDButton variant="outlined"
                                            color="secondary"
                                            iconOnly={true}
                                            circular={true}
                                            size={"small"}
                                            className={'pull-right'} onClick={() => {
                                    remove(idx);
                                  }}><Icon>close</Icon></MDButton>
                                </Grid>
                              </Grid>

                            </Col>


                          </Row>

                          {!!!entries[idx]?.adult &&
                            <>
                              <Row className={'mt-4'}>
                                <Col className={'col'} sm={12} xs={12}>
                                  <Grid container spacing={2}>
                                    <Grid item sm={6}>
                                      <h6>Minimum Attendee Age</h6>
                                      <Grid container>
                                        <Grid item sm={6}>
                                          <div className="form-group">
                                            <MDInput type="number"
                                                     min={1}
                                                     {...register(`entries[${idx}].minValue`, {
                                                       valueAsNumber: true
                                                     })}
                                                     required
                                                     InputLabelProps={{shrink: true}}
                                                     label="Minimum Value"
                                                     placeholder="ie. 6 months"
                                                     className="form-control"
                                                     autoComplete="off"
                                                     id={`entries[${idx}].minValue`}/>
                                          </div>
                                        </Grid>
                                        <Grid item sm={6}>
                                          <div className="form-group native-margin-fix">
                                            <label htmlFor="minDateType" className={"native-label"}>Date Type</label>
                                            <NativeSelect
                                              style={{
                                                position: 'relative',
                                                top: '-1px',
                                                height: '44px'
                                              }}
                                              {...register(`entries[${idx}].minDateType`, {
                                                valueAsNumber: true
                                              })}
                                              variant="outlined"
                                              id={`entries[${idx}].minDateType`} name={`entries[${idx}].minDateType`}
                                              className={'form-control'}>
                                              <option value={1}>Month</option>
                                              <option value={2}>Year</option>
                                            </NativeSelect>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item sm={6}>
                                      <h6>Maximum Attendee Age</h6>
                                      <Grid container>
                                        <Grid item sm={6}>
                                          <div className="form-group">
                                            <MDInput type="number"
                                                     min={1}
                                                     {...register(`entries[${idx}].maxValue`, {
                                                       valueAsNumber: true
                                                     })}
                                                     InputLabelProps={{shrink: true}}
                                                     label="Maximum Value"
                                                     placeholder="ie. 2 years"
                                                     className="form-control"
                                                     autoComplete="off"
                                                     id={`entries[${idx}].maxValue`}/>
                                          </div>
                                        </Grid>
                                        <Grid item sm={6}>
                                          <div className="form-group native-margin-fix">
                                            <label htmlFor="maxDateType" className={"native-label"}>Date Type</label>
                                            <NativeSelect
                                              style={{
                                                position: 'relative',
                                                top: '-1px',
                                                height: '44px'
                                              }}
                                              {...register(`entries[${idx}].maxDateType`, {
                                                valueAsNumber: true
                                              })}
                                              variant="outlined"
                                              id={`entries[${idx}].maxDateType`} name={`entries[${idx}].maxDateType`}
                                              className={'form-control'}>
                                              <option value={1}>Month</option>
                                              <option value={2}>Year</option>
                                            </NativeSelect>
                                          </div>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                </Col>
                              </Row>
                            </>
                          }

                        </Grid>
                      </Grid>
                    </div>
                  )
                })}

                <Row>
                  <Col xs={12}>
                    <div className="form-group mt-2">
                      <MDButton color="primary" className={'pull-right'} onClick={() => {
                        addEntry();
                      }}>Add Entry</MDButton>
                    </div>
                  </Col>
                </Row>


              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}